import { type ActionItem } from 'shared/ui'
import { copyClientSecret } from 'pages/settings/pages/developer/pages/applications/lib/copyClientSecret'
import { type AuthClientRow } from 'pages/settings/pages/developer/pages/applications/model/AuthClientRow'
import { type ApplicationsStore } from 'pages/settings/pages/developer/pages/applications/store/applicationsStore'

export const getApplicationsTableActions = (
  row: AuthClientRow,
  store: ApplicationsStore
): ActionItem[] => {
  return [
    {
      icon: 'copy',
      text: 'Copy client secret',
      onAction: () => copyClientSecret(row.secret),
    },
    {
      icon: 'edit',
      text: 'Edit',
      onAction: () => {
        store.openEditClientModal(row.origin)
      },
    },
    {
      icon: 'delete',
      text: 'Revoke',
      onAction: () => {
        store.openRevokeModal(row.origin)
      },
    },
  ]
}
